<template>
  <v-row class="background-color-white" no-gutters>
    <v-col class="d-flex primary--text py-2">
      <div class="align-center d-flex pl-4">
        <Icon
          :name="getDepartmentDisplayName('Menu').toLowerCase()"
          :color="$vuetify.theme.themes.light.primary"
          :title="getDepartmentDisplayName('Menu')"
          :style="{ height: '24px', width: '24px' }"
        ></Icon>
        <h3 class="pl-2 text-no-wrap">
          {{ getDepartmentDisplayName("Menu") }}
        </h3>
      </div>
    </v-col>

    <v-col cols="12">
      <v-carousel
        class="d-flex justify-center"
        v-if="menuItems"
        :height="195"
        :show-arrows="false"
        light
      >
        <v-carousel-item v-for="category in categories" :key="category.name">
          <Menu :name="category.name" :src="category.img" />
        </v-carousel-item>
      </v-carousel>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import Menu from "@/components/Departments/Menus/Menu.vue";
import Icon from "@/components/UI/Icon.vue";

export default {
  name: "XsMenus",
  components: { Icon, Menu },
  computed: {
    ...mapGetters("menu", { menuItems: "bySection" }),
    ...mapGetters("departments", {
      getDepartmentDisplayName: "getDepartmentDisplayName",
    }),
    categories() {
      return Object.entries(this.menuItems)
        .slice(0, 6)
        .map((item) => ({
          name: item[0],
          img: this.getImageFromMenuProducts(item[1]),
        }));
    },
  },
  methods: {
    getImageFromMenuProducts(products) {
      const item = products.find(({ image }) => image !== null);
      return item ? item.image : null;
    },
  },
};
</script>
<style>
.v-btn--active .v-btn__content .v-icon {
  color: var(--v-primary-base);
}
</style>
